import {Field, useFormikContext} from 'formik'
import {TextField} from 'formik-material-ui'
import React, {Fragment, useEffect} from 'react';
import {Grid, Grow, Typography} from '@material-ui/core'

import WebcamCapture from '../../../../components/Webcam'
import {StepHeader} from '../../styles'

const Step15 = () => {
  const {setFieldValue, setFieldTouched} = useFormikContext()
  useEffect(() => {
    setFieldValue('documentType', 'SELFIE')
    setFieldValue('image', '')
    setFieldTouched('documentType', false)
    setFieldTouched('image', false)
  }, [setFieldTouched, setFieldValue])
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 3 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Vamos tirar uma selfie sua, retire seus óculos ou chapéus.
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              disabled
              label="Tipo de documento"
              fullWidth
              value="SELFIE"
              name="documentType"
              component={TextField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="image"
              facingMode="user"
              component={WebcamCapture}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default Step15;
